import { Injectable } from '@angular/core';

/**
 * Globals
 */
@Injectable()
export class Globals {
  /**
   * Set default path for sprites
   */
  pathSprite = 'assets/sprites/sprite.svg#';
}
